// Angular imports
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// third party imports
import {
    DxBoxModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxSelectBoxModule,
    DxToolbarModule,
    DxDataGridModule,
    DxPopoverModule,
    DxPopupModule,
    DxFormModule,
    DxTextAreaModule,
    DxRadioGroupModule,
    DxDateBoxModule,
    DxTextBoxModule,
    DxSwitchModule,
    DxNumberBoxModule,
    DxListModule,
    DxCheckBoxModule,
    DxTagBoxModule,
    DxValidatorModule,
    DxDropDownButtonModule,
    DxFileUploaderModule
} from 'devextreme-angular';

// Module imports
import { SharedModule } from '../../shared-module/shared.module';
import { ManagementCommonModule } from '../../management-common/management-common.module';
import { CirabooksModule } from '../../cirabooks/cirabooks-module/cirabooks.module';

// Component imports
import { VendorManagementGridComponent } from './components/vendor-management-grid/vendor-management-grid.component';
import { Vendor1099ConfigurationComponent } from './components/vendor1099-configuration/vendor1099-configuration.component';
import { VendorInformationEditorComponent } from './components/vendor-information-editor/vendor-information-editor.component';
import { RemitAddressComponent } from './components/remit-address/remit-address.component';
import { VendorContactsComponent } from './components/vendor-contacts/vendor-contacts.component';
import { VendorContactEditorComponent } from './components/vendor-contact-editor/vendor-contact-editor.component';
import { VMElectronicPaymentComponent } from './components/vm-electronic-payment/vm-electronic-payment.component';
import { WorkflowAutoActionsComponent } from './components/workflow-auto-actions/workflow-auto-actions.component';
import { WorkflowAutoActionsEditorComponent } from './components/workflow-auto-actions/workflow-auto-actions-editor/workflow-auto-actions-editor.component';
import { VendorAAPWfChecklistEditorComponent } from './components/vendor-aap-wf-checklist-editor/vendor-aap-wf-checklist-editor.component';
import { VMNotesComponent } from './components/vm-notes/vm-notes.component';
import { CommunityVendorTemplateEditorComponent } from './components/community-vendor-template-editor/community-vendor-template-editor.component';
import { ManageContractsComponent } from './components/manage-contracts/manage-contracts.component';
import { ManageContractDocumentComponent } from './components/manage-contracts/manage-contract-document/manage-contract-document.component';
import { ContractEditorComponent } from './components/contract-editor/contract-editor.component';
import { CommunityVendorHistoryComponent } from './components/community-vendor-history/community-vendor-history.component';

@NgModule({
    imports: [
        CommonModule,
        DxBoxModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxSelectBoxModule,
        DxToolbarModule,
        DxDataGridModule,
        DxPopoverModule,
        DxPopupModule,
        DxFormModule,
        DxTextAreaModule,
        DxRadioGroupModule,
        DxDateBoxModule,
        DxTextBoxModule,
        DxSwitchModule,
        DxNumberBoxModule,
        DxListModule,
        DxCheckBoxModule,
        DxTagBoxModule,
        DxValidatorModule,
        DxDropDownButtonModule,
        DxFileUploaderModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        CirabooksModule, // for OverridableFormItemComponent
        SharedModule,
        ManagementCommonModule
    ],
    declarations: [
        VendorManagementGridComponent,
        Vendor1099ConfigurationComponent,
        VendorInformationEditorComponent,
        RemitAddressComponent,
        VendorContactsComponent,
        VendorContactEditorComponent,
        VMElectronicPaymentComponent,
        WorkflowAutoActionsComponent,
        WorkflowAutoActionsEditorComponent,
        VendorAAPWfChecklistEditorComponent,
        VMNotesComponent,
        CommunityVendorTemplateEditorComponent,
        ManageContractsComponent,
        ManageContractDocumentComponent,
        ContractEditorComponent,
        CommunityVendorHistoryComponent
    ],
    exports: [
        VendorManagementGridComponent,
        Vendor1099ConfigurationComponent,
        VendorInformationEditorComponent,
        RemitAddressComponent,
        VendorContactsComponent,
        VMElectronicPaymentComponent,
        WorkflowAutoActionsComponent,
        VendorAAPWfChecklistEditorComponent,
        VMNotesComponent,
        CommunityVendorTemplateEditorComponent,
        ManageContractsComponent,
        ManageContractDocumentComponent,
        ContractEditorComponent,
        CommunityVendorHistoryComponent
    ]
})
export class SharedVendorManagementModule {}
